import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import {getParameterByName} from '@/assets/commit.js'

Vue.use(Vuex)

const state = {
	resumeData: [],
	treeMore: {},
	scrollTop: 0,
	// resumeType: localStorage.getItem('resumeType'),
	parObj: {
		
	},
}

export default new Vuex.Store({
	state,
	actions,
	mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js